import { render, staticRenderFns } from "./list.vue?vue&type=template&id=65a4cd6e&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=65a4cd6e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a4cd6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a4cd6e')) {
      api.createRecord('65a4cd6e', component.options)
    } else {
      api.reload('65a4cd6e', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=65a4cd6e&scoped=true", function () {
      api.rerender('65a4cd6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commission/list.vue"
export default component.exports